import { NotepadText } from 'lucide-react';
import type { CardNoteRecord } from '@/lib/cardNotes/types';

/**
 * #976 R2: the read-only view of a trader's note, for a manager or admin. There is no textbox, no
 * Edit and no Save: only the trader can change this note.
 */
export function TraderNoteBadge({ record, open, onToggle }: { record: CardNoteRecord | undefined; open: boolean; onToggle: () => void }) {
  if (!record?.note) return null;
  return (
    <button
      type="button"
      data-trader-note-badge
      aria-label="Trader note (read-only)"
      aria-expanded={open}
      title="Trader note (read-only)"
      onClick={onToggle}
      // The same purple icon and dot the Tracker cards use for a card with a saved note.
      className={`relative ml-1.5 inline-flex shrink-0 rounded p-0.5 align-middle text-purple-400 transition-colors hover:bg-purple-400/10 ${open ? 'bg-purple-400/10' : ''}`}
    >
      <NotepadText className="h-3.5 w-3.5" aria-hidden="true" />
      <span aria-hidden="true" className="absolute top-0 right-0 h-1.5 w-1.5 rounded-full bg-purple-400" />
    </button>
  );
}

export function TraderNoteRow({ record, colSpan }: { record: CardNoteRecord; colSpan: number }) {
  return (
    <tr data-trader-note-row className="border-border/40 bg-muted/20 border-b">
      <td colSpan={colSpan} className="px-4 py-2">
        <p className="text-foreground whitespace-pre-wrap break-words text-xs">{record.note}</p>
        <p className="text-muted-foreground mt-1 text-[11px]">
          {record.updatedAt ? `Last edited ${new Date(record.updatedAt).toLocaleString()}. ` : ''}Read-only. Only the trader can edit this note.
        </p>
      </td>
    </tr>
  );
}
